export default "__VITE_ASSET__CGSy6yv0__"